const powerDashboardEvents = {
    ADD_TEMPLATES: 'ADD_TEMPLATES',
    DELETE_TEMPLATES: 'DELETE_TEMPLATES',
    UPDATE_TEMPLATES: 'UPDATE_TEMPLATES'
}

export default powerDashboardEvents